@if (isLegacy()) {
    @if (currentValue()) {
        <div
            class="cs-jackpot-ribbon"
            [class]="customClass()"
            [class.center-aligned]="alignment() === 'centered'"
            [class.left-aligned]="alignment() === 'left'">
            @if (withIcon() && isJackpotGroup()) {
                <span class="cs-hot-icon">
                    <cs-image-icon class="cs-image-icon" [imgSrc]="iconImage()" />
                </span>
            }
            <span class="jp-value" [class.visible]="withAmount()">{{
                currentValue() | csJackpotValueFormatter: withCurrency() : withCurrencyOnRight() : withAmount()
            }}</span>
        </div>
    }
}
